import { environment } from '@tv3/environments/environment'

declare const window: any

export function getLocale() {
  // tslint:disable-next-line:no-unused-expression
  const languages = environment.languages.map((l) => l.value)
  const current = window.location.pathname.split('/')[1]
  if (languages.includes(current)) {
    return current
  }
  return 'en'
}
